import 'angular:locale/data:es-MX';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "es-MX";
